import { CompanyType } from 'types'
import { useGetCompaniesDictionaryQuery } from 'store/dictionaries'

export const useInternalCompany = (company?: string | null): CompanyType | undefined => {
  const { data: companiesDictionary } = useGetCompaniesDictionaryQuery()
  return companiesDictionary?.find((item) => item.ciscoId === company)?.id
}
